import apiClient from './config';
import { Prospect, ProspectInput } from '../../types';

// D2 — personas que vienen a probar una clase.

export const fetchProspects = async (includeInactive = false): Promise<Prospect[]> => {
    const response = await apiClient.get('/prospects', {
        params: includeInactive ? { includeInactive: 'true' } : undefined,
    });
    return response.data;
};

export const fetchProspect = async (id: string): Promise<Prospect> => {
    const response = await apiClient.get(`/prospects/${id}`);
    return response.data;
};

export const createProspect = async (prospect: ProspectInput): Promise<Prospect> => {
    const response = await apiClient.post('/prospects', prospect);
    return response.data;
};

export const updateProspect = async (
    id: string,
    prospect: Partial<ProspectInput>
): Promise<Prospect> => {
    const response = await apiClient.put(`/prospects/${id}`, prospect);
    return response.data;
};

// Baja lógica. El backend además la saca de las clases futuras y ofrece esas
// plazas a la lista de espera; devuelve de cuántas clases la ha sacado.
export const deactivateProspect = async (
    id: string
): Promise<{ message: string; removedFrom: number }> => {
    const response = await apiClient.delete(`/prospects/${id}`);
    return response.data;
};

// Apuntar / quitar de una clase concreta. Endpoints propios: el PUT del evento no
// toca la lista de prospectos.
export const addProspectToEvent = async (eventId: string, prospectId: string) => {
    const response = await apiClient.post(`/eventos/${eventId}/prospects`, { prospectId });
    return response.data;
};

export const removeProspectFromEvent = async (eventId: string, prospectId: string) => {
    const response = await apiClient.delete(`/eventos/${eventId}/prospects/${prospectId}`);
    return response.data;
};
